export default __webpack_public_path__ + "static/media/404-page.f1162763.gif";